// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content {
  height: calc(100% - 30px);
  padding-bottom: 30px;
  overflow: hidden !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/inspect-widget/inspect-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,oBAAA;EACA,2BAAA;AACF","sourcesContent":[".content {\n  height: calc(100% - 30px);\n  padding-bottom: 30px;\n  overflow: hidden !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
